export default __webpack_public_path__ + "static/media/azaslogo.fbbef862.png";